var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-mask"},[_c('a-spin',{attrs:{"tip":_vm.getLabel('TIP_WAITING'),"size":"large"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }